import React from 'react';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import {ClickActionEvent } from '../../util/analytics'

import skills from "./Data"
import CustomizedProgressBars from "./Template"
 


const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 8, pb: 8 };
const sxCard = { height: '100%', display: 'flex', flexDirection: 'column' };
const sxCardHover = { ...sxCard, boxShadow: '0 4px 8px 0 rgba(0,0,255,0.8), 0 6px 20px 0 rgba(0,0,255,0.8)', cursor: 'pointer', opacity: 0.7, transition: '0.2s linear' };


export default function Skills() {
  
  

  const [selectedItem, setSelectedItem] = React.useState('')
  const [showAllSkills, setShowAllSkills] = React.useState(false)
  const visibleSkills = showAllSkills ? skills : skills.slice(0, 3)

  const MouseOver = (t)  =>{
    setSelectedItem(t)
    
  }

  const MouseOut = (event)  =>{
    setSelectedItem('')
  }

  return (
    <React.Fragment>
 
      <div>

        <Box sx={sxHeroContent}>
          <Container maxWidth="lg">
            <Typography component="h1" variant="h3" align="center" color="textPrimary" gutterBottom>
              Skills 🥇
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" paragraph>
              The beautiful thing about learning  is that no one can take it away from you - APJ Abdul Kalam ...
            </Typography>
          </Container>
        </Box>
        <Container sx={sxCardGrid} maxWidth="xl">
          <Grid style={{fontSize:"10px"}} container spacing={5} >
            {visibleSkills.map((item) => (
              <Grid item key={item.id} xs={12} sm={6} md={4} lg={3} onMouseOver={()=>MouseOver(item.name)} onMouseOut={MouseOut} sx={item.name===selectedItem?sxCardHover:sxCard}>
               <Link href={item.deployedLink} target="_blank" rel="noreferrer noopener" onClick={()=>{ClickActionEvent('Skill '+item.name, 'skills section', 'skill clicked')}}> 
                    <CustomizedProgressBars name={item.name} points={item.points} icon={CameraIcon} image={item.image}/>
                </Link>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setShowAllSkills((prev) => !prev)}
            >
              {showAllSkills ? 'Show less' : 'Show more'}
            </Button>
          </Box>
        </Container>
      </div>
 
    </React.Fragment>
  );
}
